// SETUP: replace these empty fields only with verified business contact details.
// Leave live:false for a private draft. When ready to publish, set live:true and
// provide a valid email (and optional phone) below. The site will then switch to
// a live mailto: flow using this address.
// SETUP: replace these empty fields only with verified business contact details.
// Leave live:false for a private draft. When ready to publish, set live:true and
// provide a valid email (and optional phone) below. The site will then switch to
// a live mailto: flow using this address.
//
// GOOGLE BUSINESS PROFILE HOOKUP (paste after verification):
//   googleReviewUrl   - The short "leave a review" link from Google Business Profile.
//                       In GBP dashboard: "Get more reviews" -> "Share review form" -> copy URL.
//                       Looks like: https://g.page/r/XXXXXXXXX/review
//   googleProfileUrl  - The main public profile URL (Google Maps link).
//                       In GBP dashboard: "Share your business profile" -> copy URL.
//                       Looks like: https://maps.app.goo.gl/XXXXXXXX
//   googlePlaceId     - The Place ID (used for the embedded profile map).
//                       Get it at https://developers.google.com/maps/documentation/places/web-service/place-id
//                       Looks like: ChIJXXXXXXXXXXXXXXXXX
const BUSINESS = {
  live: true,
  email: "Jason@jkmcoastalcarpentry.com",
  phone: "5083207992",
  phoneDisplay: "(508) 320-7992",
  googleReviewUrl: "",
  googleProfileUrl: "",
  googlePlaceId: "",
};

export default BUSINESS;
